import {parseNumber} from '../../utils/numerals/parseNumber';
import {spaceNumber} from '../../utils/numerals/spaceNumber';
import {timestampToQuater} from '../../utils/numerals/timestampToQuater';
import {trigger} from '../../utils/events/trigger';

let rangeHandler = null;
let rangeInput = null;
let rangeInputTimeout = 0;
let pr;

export const updateRange = ( argument, reset ) => {
	let p = null;
	let dp = 0;
	let isFloat = false;

	if ( typeof argument === 'number' && rangeHandler !== null )
	{
		p = rangeHandler.closest( 'div.range' );
	}
	else if ( rangeInput !== null )
	{
		p = rangeInput.closest( 'div.range' );
	}
	else
	{
		p = argument.closest( 'div.range' );
	}

	if ( p === null )
	{
		return;
	}

	if ( p.querySelector( 'ul.inputs' ).dataset.decimalPlaces > 0 )
	{
		isFloat = true;
		dp = p.querySelector( 'ul.inputs' ).dataset.decimalPlaces;
	}

	const d = parseNumber( p.dataset.min, isFloat );
	const min = 0;
	const max = parseNumber( p.dataset.max, isFloat ) - d;
	const step = parseNumber( p.querySelector( 'ul.inputs' ).dataset.step, isFloat );
	let uMin = parseNumber( p.querySelector( 'input.user-min' ).value.replace( / /g, '' ), isFloat, true ) - d;
	let uMax = parseNumber( p.querySelector( 'input.user-max' ).value.replace( / /g, '' ), isFloat ) - d;
	let moveOtherRange = false;

	if ( typeof argument === 'number' && rangeHandler !== null )
	{
		if ( !pr )
		{
			pr = argument;
		}
		else
		{
			p.querySelector( 'button.min' ).style.zIndex = '';
			p.querySelector( 'button.max' ).style.zIndex = '';

			if ( pr >= argument && uMin === uMax )
			{
				p.querySelector( 'button.min' ).style.zIndex = 10;
				pr = null;
			}

			if ( pr < argument && uMin === uMax )
			{
				p.querySelector( 'button.max' ).style.zIndex = 10;
				pr = null;
			}
		}

		if ( rangeHandler.classList.contains( 'min' ) )
		{
			if ( argument > ( ( uMax - step ) * 100 ) / ( max - min ) )
			{
				moveOtherRange = true;
			}

			uMin = ( max - min ) * argument / 100;

			if ( moveOtherRange )
			{
				uMax = uMin + step;

				if ( uMax > max )
				{
					uMin -= step;
				}
			}
		}

		if ( rangeHandler.classList.contains( 'max' ) )
		{
			if ( argument < ( ( uMin + step ) * 100 ) / ( max - min ) )
			{
				moveOtherRange = true;
			}

			uMax = ( max - min ) * argument / 100;

			if ( moveOtherRange )
			{
				uMin = uMax - step;

				if ( uMin > min )
				{
					uMax += step;
				}
			}
		}
	}
	else if ( reset )
	{
		uMin = min;
		uMax = max;
	}

	if ( isNaN( uMin ) || uMin < min )
	{
		uMin = min;
	}

	if ( isNaN( uMax ) || uMax > max )
	{
		uMax = max;
	}

	if ( uMin >= uMax )
	{
		uMin = uMax - step;
	}

	if ( uMax <= min )
	{
		uMax = min + step;
	}

	if ( uMax < uMin )
	{
		uMax = uMin + step;
	}

	uMin = parseNumber( uMin, isFloat, true );
	uMax = parseNumber( uMax, isFloat );

	const vMin = uMin * 100 / ( max - min );
	const vMax = uMax * 100 / ( max - min );

	p.querySelector( 'button.min' ).style.left = vMin + '%';
	p.querySelector( 'button.max' ).style.left = vMax + '%';
	p.querySelector( 'span.range' ).style.left = vMin + '%';
	p.querySelector( 'span.range' ).style.right = 100 - vMax + '%';

	let inputUserMinVal = ( uMin + d ).toFixed( dp );
	let inputUserMaxVal = ( uMax + d ).toFixed( dp );

	if ( !p.classList.contains( 'ready' ) )
	{
		p.classList.add( 'ready' );
	}

	if ( p.dataset.format === 'price' )
	{
		inputUserMinVal = spaceNumber( inputUserMinVal );
		inputUserMaxVal = spaceNumber( inputUserMaxVal );
	}
	else if ( p.dataset.format === 'area' )
	{
		inputUserMinVal = inputUserMinVal.replace( '.', ',' );
		inputUserMaxVal = inputUserMaxVal.replace( '.', ',' );
	}
	else if ( p.dataset.format === 'deadline' )
	{
		p.querySelector( 'input.user-min' ).value = inputUserMinVal;
		p.querySelector( 'input.user-max' ).value = inputUserMaxVal;
		inputUserMinVal = timestampToQuater( inputUserMinVal );
		inputUserMaxVal = timestampToQuater( inputUserMaxVal );
		p.querySelector( 'span.focus-out.min' ).innerHTML = inputUserMinVal;
		p.querySelector( 'span.focus-out.max' ).innerHTML = inputUserMaxVal;

		return;
	}

	p.querySelector( 'input.user-min' ).value = inputUserMinVal;
	p.querySelector( 'input.user-max' ).value = inputUserMaxVal;
};

export const initRange = () => {
	const ranges = document.querySelectorAll( 'div.range' );

	if ( !ranges.length )
	{
		return;
	}

	const initButton = ( evt ) => {
		document.body.classList.add( 'range-dragging' );
		rangeHandler = evt.target;
	};

	const moveButton = ( x ) => {
		if ( !document.body.classList.contains( 'range-dragging' ) )
		{
			return;
		}

		const rs = rangeHandler.closest( 'div.range' ).querySelector( 'div.controls' ).getBoundingClientRect().left;
		const width = rangeHandler.closest( 'div.range' ).querySelector( 'div.controls' ).offsetWidth;
		let p = ( x - rs ) / width * 100;
		
		if ( p < 0 )
		{
			p = 0;
		}
		else if ( p > 100 )
		{
			p = 100;
		}

		updateRange( p );
	};

	const releaseButton = () => {
		if ( !document.body.classList.contains( 'range-dragging' ) )
		{
			return;
		}

		document.body.classList.remove( 'range-dragging' );

		const inputToTrigger = rangeHandler.classList.contains( 'min' ) ? rangeHandler.closest( 'div.range' ).querySelector( 'input.user-min' ) : rangeHandler.closest( 'div.range' ).querySelector( 'input.user-max' );

		trigger( inputToTrigger, 'change' );
		rangeHandler = null;
	};

	Array.from( ranges ).forEach( ( it ) => {
		const UPDATE_TIMEOUT = setTimeout( () => {
			updateRange( it );
			clearTimeout( UPDATE_TIMEOUT );
		}, 100 );

		it.querySelector( 'input' ).addEventListener( 'keydown', ( evt ) => {
			if ( !/\d|\s/.test( evt.key ) && evt.key !== 'Backspace' && evt.key !== 'Delete' && evt.key !== 'ArrowLeft' && evt.key !== 'ArrowRight' )
			{
				evt.preventDefault();
				return;
			}

			clearTimeout( rangeInputTimeout );
			rangeInput = evt.target;

			rangeInputTimeout = setTimeout( () => {
				updateRange( rangeInput.value );
			}, 1000 );
		} );

		it.querySelector( 'button.min' ).addEventListener( 'mousedown', initButton );
		it.querySelector( 'button.min' ).addEventListener( 'touchstart', initButton, {passive: true} );
		it.querySelector( 'button.max' ).addEventListener( 'mousedown', initButton );
		it.querySelector( 'button.max' ).addEventListener( 'touchstart', initButton, {passive: true} );
	} );

	document.body.addEventListener( 'mousemove', ( evt ) => {
		const x = evt.pageX;

		moveButton( x );
	} );

	document.body.addEventListener( 'touchmove', ( evt ) => {
		const x = evt.touches[0].pageX;

		moveButton( x );
	} );

	document.body.addEventListener( 'mouseup', releaseButton );
	document.body.addEventListener( 'touchend', releaseButton );

	const resetButton = document.querySelector( 'button[type="reset"]' );

	if ( !resetButton )
	{
		return;
	}

	resetButton.addEventListener( 'click', () => {
		Array.from( ranges ).forEach( ( it ) => {
			const UPDATE_TIMEOUT = setTimeout( () => {
				updateRange( it, true );
				clearTimeout( UPDATE_TIMEOUT );
			}, 100 );
		} );
	} );
};
